import "./index.scss"

const GAM_SLOT_SELECTOR = ".affiliate-bar__blue-bar-item[id^='cont_bn_blue_bar']"

function hideParentListItem(slotDiv: HTMLElement): void {
  const listItem = slotDiv.closest("li.gam-unit-blue-bar") as HTMLElement | null
  if (!listItem) return

  listItem.style.display = "none"
}

function shouldHideSlot(slotDiv: HTMLElement): boolean {
  const lifecycle = slotDiv.getAttribute("data-adbridg-slot-lc") ?? ""
  const isMarkedUnfilled = /rendered=unfilled/.test(lifecycle)
  const hasCreativeElements = !!slotDiv.querySelector("iframe, a[href], img[src]")

  return isMarkedUnfilled || !hasCreativeElements
}

function hideEmptyGamSlots(): void {
  document.querySelectorAll<HTMLElement>(GAM_SLOT_SELECTOR).forEach((slotDiv) => {
    if (shouldHideSlot(slotDiv)) {
      hideParentListItem(slotDiv)
    }
  })
}

function watchGamSlotUpdates(): void {
  const list = document.querySelector(".affiliate-bar__list")
  if (!list) return

  const observer = new MutationObserver(() => hideEmptyGamSlots())
  observer.observe(list, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["style", "data-adbridg-slot-lc"],
  })

  // Keep observer bounded; by this point ad slots should have resolved.
  window.setTimeout(() => observer.disconnect(), 60000)
}

function runWhenReady(): void {
  const runChecks = () => {
    hideEmptyGamSlots()
    watchGamSlotUpdates()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runChecks)
  } else {
    runChecks()
  }
}

runWhenReady()
